import { HueSaturationEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const HueSaturation = wrapEffect(HueSaturationEffect)
